<template>
  <CommonPanel :ifShowMore="true" moreTarget="_blank" moreLink="https://shop.haiziwang.com/dataanalyse/home">
    <span slot="title">
      <label>销售数据</label>
      <label class="tip" v-if="dataUpdateTime !== ''">更新时间：{{dataUpdateTime}}</label>
    </span>
    <div class="card-container">
      <salesdata-card title="销售金额(万元)" tip="销售金额=支付金额-取消金额-退款金额" 
        :todayVal="totalSaleAmount" :yesterdayVal="totalSaleAmountHb" />
      <salesdata-card title="支付客户数" tip="统计周期内，支付操作发生日期成功支付的累计会员数量"
        :todayVal="totalPayCustCnt" :yesterdayVal="totalPayCustCntHb" />
      <salesdata-card title="支付金额(万元)" tip="统计周期内，支付操作发生日期成功支付的累计订单金额"
        :todayVal="totalPayAmount" :yesterdayVal="totalPayAmountHb" />
      <salesdata-card title="支付订单量" tip="统计周期内，支付操作发生日期成功支付的累计订单数量"
        :todayVal="totalPayTradeCnt" :yesterdayVal="totalPayTradeCntHb" />
      <salesdata-card title="退款金额(元)" tip="统计周期内，退款操作发生日期成功退款的累计订单金额"
        :todayVal="totalRefundAmount" :yesterdayVal="totalRefundAmountHb" />
      <salesdata-card title="取消金额(元)" tip="统计周期内，取消操作发生日期成功取消的累计订单金额"
        :todayVal="totalCancelAmount" :yesterdayVal="totalCancelAmountHb" />
    </div>
  </CommonPanel>
</template>
<script>
  import CommonPanel from "@/components/common-panel/index"
  import { Icon } from 'ant-design-vue'
  import Card from './_salesdata-card.vue'
  export default {
    name: 'sales-data',
    components: {
      CommonPanel,
      [Icon.name]: Icon,
      [Card.name]: Card
    },
    data() {
      return {
        dataUpdateTime: '',
        totalSaleAmount: '', // 销售金额(万元)
        totalSaleAmountHb: '', // 昨日销售金额(万元)
        totalPayCustCnt: '', // 支付客户数
        totalPayCustCntHb: '', // 昨日支付客户数
        totalPayAmount: '', // 支付金额(万元)
        totalPayAmountHb: '', // 昨日支付金额(万元)
        totalPayTradeCnt: '', // 支付订单量
        totalPayTradeCntHb: '', // 昨日支付订单量
        totalRefundAmount: '', // 退款金额(元)
        totalRefundAmountHb: '', // 昨日退款金额(元)
        totalCancelAmount: '', // 取消金额(元)
        totalCancelAmountHb: '', // 昨日取消金额(元)
      }
    },
    created() {
      this.getRealTimeOverview()
    },
    methods: {
      async getRealTimeOverview() {
        const res = await this.$store.dispatch('brandHome/queryRealTimeOverview')
        if (res && +res.code === 0 && res.data) {
          const { dataUpdateTime, totalSaleAmount, totalSaleAmountHb, 
                  totalPayCustCnt, totalPayCustCntHb, totalPayAmount, 
                  totalPayAmountHb, totalPayTradeCnt, totalPayTradeCntHb, 
                  totalRefundAmount, totalRefundAmountHb, 
                  totalCancelAmount, totalCancelAmountHb } = res.data
          this.dataUpdateTime = dataUpdateTime || ''
          this.totalSaleAmount = isNaN(totalSaleAmount) ? '-' : (+totalSaleAmount / 10000).toFixed(2)
          this.totalSaleAmountHb = isNaN(totalSaleAmountHb) ? '-' : (+totalSaleAmountHb / 10000).toFixed(2)
          this.totalPayCustCnt = isNaN(totalPayCustCnt) ? '-' : totalPayCustCnt
          this.totalPayCustCntHb = isNaN(totalPayCustCntHb) ? '-' : totalPayCustCntHb
          this.totalPayAmount = isNaN(totalPayAmount) ? '-' : (+totalPayAmount / 10000).toFixed(2)
          this.totalPayAmountHb = isNaN(totalPayAmountHb) ? '-' : (+totalPayAmountHb / 10000).toFixed(2)
          this.totalPayTradeCnt = isNaN(totalPayTradeCnt) ? '-' : totalPayTradeCnt
          this.totalPayTradeCntHb = isNaN(totalPayTradeCntHb) ? '-' : totalPayTradeCntHb
          this.totalRefundAmount = isNaN(totalRefundAmount) ? '-' : totalRefundAmount
          this.totalRefundAmountHb = isNaN(totalRefundAmountHb) ? '-' : totalRefundAmountHb
          this.totalCancelAmount = isNaN(totalCancelAmount) ? '-' : totalCancelAmount
          this.totalCancelAmountHb = isNaN(totalCancelAmountHb) ? '-' : totalCancelAmountHb
        }
      }
    }
  }
</script>
<style scoped>
  .tip {
    margin-left: 20px;
    color: #666;
    font-size: 12px;
  }
  .card-container {
    display: flex;
    justify-content: space-between;
  }
</style>
